/*
 * @Author: cui
 * @Date: 2020-08-03
 * */

/**
 * 拦截器的配置
 */
import axios from "axios";
import qs from "qs";
import router from "../routes";
import store from "@/store";
import { MessageBox, Toast } from "mint-ui";
import LocalStorage from "@/services/storage";
import { requestCode } from "@/env";
import $ from "jquery";
const proxy = require("@/env/proxy");
const proxyPath = proxy.proxyPath;
// 创建实例时设置配置的默认值
const guid = () => {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return (
    S4() +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    S4() +
    S4()
  );
};
const service = axios.create({
  baseURL: proxyPath,
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
    Accept: "application/json, text/javascript, */*; q=0.01",
  },
  // headers: {
  //   // "Content-Type": "application/x-www-form-urlencoded",
  //   // Accept: "application/json, text/javascript, */*; q=0.01"
  // },
  responseType: "json",
  timeout: 1000 * 60, // 请求超时的时间
  // 对响应的数据进行处理
  transformResponse: [
    function(data) {
      return data;
      // return JSON.parse(data);
    },
  ],
  // 对请求的数据进行处理
  transformRequest: [
    function(data) {
      console.log("proxyPath:::" + proxyPath);
      console.log("处理data1111111:" + data);
      let loginDate = LocalStorage.getLocalStorage("loginStatus");
      // if (data.token && !loginDate) {
      //   // router.push("login");
      // }
      // return qs.stringify(data);
      // console.log("处理data", JSON.stringify(data))
      return JSON.stringify(data);
      // console.log("处理data", JSON.stringify(data))
      // return data;
    },
  ],
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    store.dispatch("openLoading");
    return config;
  },
  (err) => {
    setTimeout(() => {
      store.dispatch("closeLoading");
    }, 50);
    Toast({ message: "加载超时", position: "middle" });
    return Promise.reject(err);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    if (res) {
      let data = res.data;
      console.log(data);
      // 非登录 -- 路由重定向
      if (
        data &&
        data.resultCode &&
        data.resultCode !== "SUCCESS" &&
        data.resultCode !== "REFUND_SUCCESS"
      ) {
        setTimeout(() => {
          store.dispatch("closeLoading");
        }, 50);
        if (data.resultCode === "000001") {
          setTimeout(() => {
            store.dispatch("logout");
            router.push("mainpage");
          }, 200);
        }
      }
    }
    return res;
  },
  (err) => {
    console.log(err);
    setTimeout(() => {
      store.dispatch("closeLoading");
    }, 50);
    if (err.response) {
      switch (err.response.status) {
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          store.dispatch("logout");
          router.replace({
            path: "login",
            query: { redirect: router.currentRoute.fullPath },
          });
      }
    }
    Toast({ message: "服务器有事离开一下，马上就回来", position: "middle" });
    return Promise.reject(err);
  }
);

export default service;
